export default __webpack_public_path__ + "static/main_bg-08f6890281ee8618bdd43670fb38417a.png";